import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const surveyContent = document.querySelector('.survey-content');
      const containerScroll = surveyContent ? surveyContent.scrollTop : 0;
      
      if (scrollTop > 300 || containerScroll > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    
    const surveyContent = document.querySelector('.survey-content');
    if (surveyContent) {
      surveyContent.addEventListener('scroll', toggleVisibility);
    }

    toggleVisibility();

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      if (surveyContent) {
        surveyContent.removeEventListener('scroll', toggleVisibility);
      }
    };
  }, []);

  const scrollToTop = () => {
    const surveyContent = document.querySelector('.survey-content');
    if (surveyContent && surveyContent.scrollTop > 0) {
      surveyContent.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-to-top" title="Scroll to top">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 15l-6-6-6 6" />
          </svg>
        </button>
      )}
    </>
  );
}

export default ScrollToTop;
